// extracted by mini-css-extract-plugin
export default {"more":"style_more_hqUnr","icon":"style_icon_vSEtU","moreIcon":"style_moreIcon_qUTh0 style_more_hqUnr style_icon_vSEtU","title_04":"style_title_04_Fgma2"};